import request from '@/utils/httpRequest'

export default class InfacyHouseholdAcceptanceService {
    queryById(id) {
        return request({
            url: '/infacy/wuyeInfacyHouseholdAcceptance/queryById',
            method: 'get',
            params: { id: id, acceptanceMark: '1' }
        })
    }

    startFlow(params) {
        return request({
            url: '/infacy/wuyeInfacyHouseholdAcceptance/startFlow',
            method: 'post',
            data: params
        })
    }

    questionTypelist (params) {
        return request({
            url: '/infacy/wuyeInfacyQuestionType/lists',
            method: 'get',
            params: params
        })
    }

}
